import React from 'react'
import NavbarContainer from '../components/NavbarContainer/NavbarContainer'
import RegistrationConditionsContainer from '../components/RegistrationConditionsContainer/RegistrationConditionsContainer'

function RegistrationConditions() {
  return (
    <div>
      <NavbarContainer/>
      <RegistrationConditionsContainer/>
    </div>
  )
}

export default RegistrationConditions